import { factory, Flex, Typography, omitText, Link, Box } from '@kohler-dsm-library/kohler-core';
import { ExternalLinkIcon, ArrowRightBoldIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { useId } from 'react';
import { slugify } from '../LanguageMenu/LanguageMenu.utils.mjs';
import classes from './OverlayMenuLinks.module.css.mjs';
import { omitTextAndTabGroup } from './OverlayMenuLinks.utils.mjs';

const OverlayMenuLinks = factory((props, ref) => {
  const { className, title, items, CTAs, size = "small", isCTA = false, newTabGroup = false, ...rest } = props;
  const isSmall = size === "small";
  const titleID = useId();
  return /* @__PURE__ */ React.createElement(
    Flex,
    {
      ref,
      direction: "column",
      align: "flex-start",
      className: clsx(
        className,
        "kohler-overlay-menu-links",
        classes.overlayMenuLinks,
        isSmall && !items?.length && title.href && classes.overlayMenuLinksNoMargin
      ),
      ...rest
    },
    title && (!isCTA ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: title.href ? "a" : "span",
        size: isSmall ? "label-medium-m" : "label-regular-s",
        textColor: isSmall ? "var(--content-primary)" : "var(--content-secondary)",
        className: clsx(
          title.href && classes.overlayMenuCategoryLinksTitleLink,
          newTabGroup && classes.overlayMenuCategoryLinksTitleLinkCTA
        ),
        id: `${title.text ? slugify(title.text) : ""}-${titleID}`,
        target: title.href ? newTabGroup ? "_blank" : void 0 : void 0,
        ...omitText(title)
      },
      title.text,
      newTabGroup && /* @__PURE__ */ React.createElement(ExternalLinkIcon, { size: "small", withBoundingBox: false })
    )) : /* @__PURE__ */ React.createElement(Link, { size: "small", underline: false, rightIcon: /* @__PURE__ */ React.createElement(ArrowRightBoldIcon, { size: "small", withBoundingBox: false }), ...omitText(title) }, title.text)),
    items?.length && items?.length > 0 && /* @__PURE__ */ React.createElement(
      Flex,
      {
        component: "ul",
        direction: "column",
        gap: 2,
        "aria-labelledby": title && `${title.text ? slugify(title.text) : ""}-${titleID}`,
        className: classes.overlayMenuLinksList
      },
      items?.map((item) => {
        if ("href" in item) {
          return /* @__PURE__ */ React.createElement(Box, { key: item.text || item.href, component: "li", className: classes.overlayMenuCategoryLinksLink }, isSmall && item.target !== "_blank" && !item.newTabGroup && /* @__PURE__ */ React.createElement(
            Typography,
            {
              component: "a",
              size: "navigation-overlay-item-s",
              textColor: "var(--content-action-default)",
              ...omitTextAndTabGroup(item),
              className: classes.overlayMenuCategoryLinksLink
            },
            item.text
          ), (!isSmall || item.target === "_blank" || item.newTabGroup) && /* @__PURE__ */ React.createElement(
            Link,
            {
              size: "medium",
              rightIcon: item.target === "_blank" || item.newTabGroup ? /* @__PURE__ */ React.createElement(ExternalLinkIcon, { size: "small", withBoundingBox: false }) : void 0,
              ...omitTextAndTabGroup(item),
              underline: false,
              className: classes.overlayMenuCategoryLinksLinkComponent
            },
            item.text
          ));
        } else {
          return /* @__PURE__ */ React.createElement(
            OverlayMenuLinks,
            {
              component: "li",
              key: `group-${item.title?.text ?? Math.random()}`,
              ...item
            }
          );
        }
      })
    ),
    CTAs && /* @__PURE__ */ React.createElement(
      Flex,
      {
        component: "ul",
        direction: "column",
        gap: isSmall ? 10 : 2,
        marginTop: isSmall ? 10 : 2,
        className: classes.overlayMenuLinksList
      },
      CTAs?.map((link) => /* @__PURE__ */ React.createElement(Box, { key: link.href, component: "li", className: classes.overlayMenuCategoryLinksCTA }, /* @__PURE__ */ React.createElement(
        Link,
        {
          size: isSmall ? "small" : "medium",
          underline: false,
          rightIcon: isSmall ? /* @__PURE__ */ React.createElement(ArrowRightBoldIcon, { size: "small", withBoundingBox: false }) : /* @__PURE__ */ React.createElement(ExternalLinkIcon, { withBoundingBox: false }),
          ...omitText(link)
        },
        link.text
      )))
    )
  );
});

export { OverlayMenuLinks };
